<script setup lang="ts">
import { CVR_UPLOADS_HEADER, SELECTABLE_UPLOAD_STATUSES } from "@/services/consts/cvr_upload"
import HeaderComponent from "@/components/CvrConvert/HeaderComponent.vue"
import Row from "@/components/CvrConvert/CvrUploadListRow.vue";
import { ref, Ref, computed } from 'vue'
import i18n from '@/lang/i18n';
import getAccountResponse from "@/types/responses/getAccount"
import CvrUpload from "@/types/CvrUpload";

const emits = defineEmits(['update:modelValue', 'search'])
const props = defineProps<{
  items: CvrUpload[]
  showFlash: (message: string, type: string, fadeout: boolean) => { value: any }
  reload: () => void
  listLoading: boolean
  accounts: getAccountResponse
  updateAuthority: boolean
  modelValue: {
    [key: string]: string[];
  }
  isManagementOffice: boolean
}>();

type selectableItemType = {
  id: string | number;
  key: string;
  label: string;
}

const expandRowId: Ref<number | null> = ref(null);
const searchWindowStatus: Ref<boolean> = ref(false);
const selectableItems: Ref<{[key: string]: selectableItemType[]}> = ref({
  status: SELECTABLE_UPLOAD_STATUSES
})

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emits("update:modelValue", value);
  },
});

function setExpandRowId(id: number) {
  if (expandRowId.value == id) {
    expandRowId.value = null
  } else {
    expandRowId.value = id
  }
}

function filterList() {
  searchWindowStatus.value = false
  emits("search");
}
</script>
<template>
  <p class="small">{{i18n.global.t('pages.cvr_uploads.holdMessages.noticeMessage')}}</p>
  <div class="list cvr-list-table">
    <template v-if="listLoading">
      <div class="not-searched">
        <label>
          {{ i18n.global.t('pages.common.list.reading') }}
        </label>
      </div>
    </template>
    <div class="list table-scrollbar">
      <v-table>
        <HeaderComponent
          v-model="modelValue"
          :headerLabels="CVR_UPLOADS_HEADER"
          :items="selectableItems"
          @search="filterList"
        />
        <tbody>
          <template
            v-for="item in props.items"
            :key="'cvr_uploads_' + item?.id"
          >
            <Row
              :item="item"
              :showFlash="props.showFlash"
              :expandRowId="expandRowId"
              :setExpandRowId="setExpandRowId"
              :reload="props.reload"
              :accounts="props.accounts"
              :updateAuthority="props.updateAuthority"
              :isManagementOffice="props.isManagementOffice"
            />
          </template>
        </tbody>
      </v-table>
    </div>
  </div>
</template>
<style>
.cvr-list-table .list .v-table__wrapper {
  max-height: 35.5vw;
  min-height: 35.5vw;
}
.cvr-list-table .list .v-table__wrapper tr{
  height: 57px;
}
.cvr-list-table table th {
  position: sticky;
  top: 0;
  background-color: #f8f9fa;
}
</style>
<style scoped>
.cvr-list-table {
  position: relative;
}
.list .list {
  overflow: auto;
}
th {
  z-index: 100;
}
.icon-column {
  width: 24px;
}
.status-column {
  width: max-content;
  padding: 0 10px;
  display: inline-block;
}
.camera-type-column {
  width: max-content;
  padding: 0 10px;
}
.hold-th > div {
  padding: 0em;
  width: 100% !important;
  text-align: center;
  white-space: nowrap;
}
</style>
